import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const en = {
  dashboard: 'Dashboard',
  clients: 'Clients',
  projects: 'Projects',
  tasks: 'Tasks',
  team: 'Team',
  finance: 'Finance',
  drive: 'Drive',
  settings: 'Settings',
  auditLog: 'Audit Log',
  notifications: 'Notifications',
  profile: 'Profile',
  search: 'Search',
  light: 'Light',
  dark: 'Dark',
  myDashboard: 'My Dashboard',
  myProjects: 'My Projects',
  myTasks: 'My Tasks',
  invoices: 'Invoices',
  myDrive: 'My Drive',
  clientProfile: 'Client Profile',
  overview: 'Overview',
  services: 'Services',
  files: 'Files',
  activity: 'Activity',
  paid: 'Paid',
  remaining: 'Remaining',
  contractValue: 'Contract Value',
};

const ar = {
  dashboard: 'لوحة التحكم',
  clients: 'العملاء',
  projects: 'المشاريع',
  tasks: 'المهام',
  team: 'الفريق',
  finance: 'المالية',
  drive: 'الملفات',
  settings: 'الإعدادات',
  auditLog: 'سجل العمليات',
  notifications: 'الإشعارات',
  profile: 'الملف الشخصي',
  search: 'بحث',
  light: 'فاتح',
  dark: 'داكن',
  myDashboard: 'لوحتي',
  myProjects: 'مشاريعي',
  myTasks: 'مهامي',
  invoices: 'الفواتير',
  myDrive: 'ملفاتي',
  clientProfile: 'ملف العميل',
  overview: 'نظرة عامة',
  services: 'الخدمات',
  files: 'الملفات',
  activity: 'النشاط',
  paid: 'مدفوع',
  remaining: 'المتبقي',
  contractValue: 'قيمة التعاقد',
};

const phraseAr = {
  ...Object.fromEntries(Object.keys(en).map(key => [en[key], ar[key]])),
  'Add': 'إضافة',
  'Add Client': 'إضافة عميل',
  'Add Activity': 'إضافة نشاط',
  'Actions': 'الإجراءات',
  'Active': 'نشط',
  'Active Projects': 'المشاريع النشطة',
  'All': 'الكل',
  'All clients': 'كل العملاء',
  'All currency': 'كل العملات',
  'Assignee': 'المكلف',
  'Auto-Delete After (optional)': 'حذف تلقائي بعد (اختياري)',
  'Auto-Delete At (optional)': 'حذف تلقائي في (اختياري)',
  'Avg Progress': 'متوسط التقدم',
  'Avg Project Progress': 'متوسط تقدم المشاريع',
  'Back': 'رجوع',
  'Cancel': 'إلغاء',
  'Client': 'العميل',
  'Client Profile': 'ملف العميل',
  'Clients': 'العملاء',
  'Company': 'الشركة',
  'Completed': 'مكتمل',
  'Contact': 'جهة التواصل',
  'Contract Value': 'قيمة التعاقد',
  'Create First Folder': 'إنشاء أول مجلد',
  'Create Folder': 'إنشاء مجلد',
  'Dashboard': 'لوحة التحكم',
  'Delete': 'حذف',
  'Display Name': 'الاسم الظاهر',
  'Download': 'تحميل',
  'Draft': 'مسودة',
  'Drafts': 'المسودات',
  'Drive': 'الملفات',
  'Due': 'تاريخ التسليم',
  'Due Date': 'تاريخ الاستحقاق',
  'Due This Week': 'مستحق هذا الأسبوع',
  'Edit': 'تعديل',
  'Edit File': 'تعديل الملف',
  'Email': 'البريد الإلكتروني',
  'Export CSV': 'تصدير CSV',
  'File': 'ملف',
  'Files': 'الملفات',
  'Finance': 'المالية',
  'Folder': 'المجلد',
  'Folder Name *': 'اسم المجلد *',
  'Follow-up': 'متابعة',
  'Industry': 'المجال',
  'In Progress': 'قيد التنفيذ',
  'Invoice': 'فاتورة',
  'Invoice #': 'رقم الفاتورة',
  'Issue Date': 'تاريخ الإصدار',
  'Linked Invoice': 'فاتورة مرتبطة',
  'Linked Project': 'مشروع مرتبط',
  'Loading...': 'جاري التحميل...',
  'Mark Paid': 'تحديد كمدفوع',
  'My Drive': 'ملفاتي',
  'My Folders': 'مجلداتي',
  'My Projects': 'مشاريعي',
  'My Projects Progress': 'تقدم مشاريعي',
  'Name': 'الاسم',
  'New Folder': 'مجلد جديد',
  'New Invoice': 'فاتورة جديدة',
  'No account': 'لا يوجد حساب',
  'No clients found': 'لا يوجد عملاء',
  'No data yet': 'لا توجد بيانات بعد',
  'No file link': 'لا يوجد ربط ملف',
  'No files yet': 'لا توجد ملفات بعد',
  'No folders yet': 'لا توجد مجلدات بعد',
  'No invoice link': 'لا يوجد ربط فاتورة',
  'No invoices found': 'لا توجد فواتير',
  'No overdue invoices': 'لا توجد فواتير متأخرة',
  'No project link': 'لا يوجد ربط مشروع',
  'No projects assigned yet': 'لا توجد مشاريع مخصصة بعد',
  'No projects yet': 'لا توجد مشاريع بعد',
  'No tasks yet': 'لا توجد مهام بعد',
  'No urgent due dates this week': 'لا توجد مواعيد عاجلة هذا الأسبوع',
  'Notes': 'ملاحظات',
  'Notifications': 'الإشعارات',
  'Outstanding': 'المستحق',
  'Overall Progress': 'التقدم العام',
  'Overdue': 'متأخر',
  'Overdue Invoices': 'الفواتير المتأخرة',
  'Paid': 'مدفوع',
  'Payment History': 'سجل المدفوعات',
  'Pending Tasks': 'المهام المعلقة',
  'Planning': 'تخطيط',
  'Priority': 'الأولوية',
  'Profile': 'الملف الشخصي',
  'Quotations': 'عروض الأسعار',
  'Services & Contract': 'الخدمات والتعاقد',
  'Role Permissions': 'صلاحيات الأدوار',
  'Quotation Template': 'قالب عرض السعر',
  'Service Packages': 'باقات الخدمات',
  'Preview': 'معاينة',
  'Export PDF': 'تصدير PDF',
  'Approve': 'موافقة',
  'Reject': 'رفض',
  'Conversion Rate': 'معدل التحويل',
  'Paid Revenue': 'الإيراد المدفوع',
  'Quote Value': 'قيمة عروض الأسعار',
  'Unified Timeline': 'الخط الزمني الموحد',
  'Active Services': 'الخدمات النشطة',
  'Progress': 'التقدم',
  'Project': 'المشروع',
  'Project Status': 'حالة المشاريع',
  'Projects': 'المشاريع',
  'Projects Done': 'المشاريع المكتملة',
  'Recent Invoices': 'آخر الفواتير',
  'Recent Projects': 'آخر المشاريع',
  'Recent Tasks': 'آخر المهام',
  'Remaining': 'المتبقي',
  'Review': 'مراجعة',
  'Search clients...': 'ابحث في العملاء...',
  'Search invoices...': 'ابحث في الفواتير...',
  'Select a client to view their drive': 'اختر عميلًا لعرض ملفاته',
  'Select a folder to view files': 'اختر مجلدًا لعرض الملفات',
  'Sent': 'مرسلة',
  'Settings': 'الإعدادات',
  'Status': 'الحالة',
  'Subfolder': 'مجلد فرعي',
  'Subfolders': 'المجلدات الفرعية',
  'Task': 'مهمة',
  'Task Completion': 'إنجاز المهام',
  'Tasks': 'المهام',
  'Team': 'الفريق',
  'Team Members': 'أعضاء الفريق',
  'Timeline': 'الخط الزمني',
  'Title': 'العنوان',
  'Total': 'الإجمالي',
  'Total Clients': 'إجمالي العملاء',
  'Total Collected': 'إجمالي المحصل',
  'Total Projects': 'إجمالي المشاريع',
  'Type': 'النوع',
  'Unassigned': 'غير مخصص',
  'Upload': 'رفع',
  'Upload File': 'رفع ملف',
  'Upload First File': 'رفع أول ملف',
  'Uploaded': 'تم الرفع',
  'Your files': 'ملفاتك',
  'active': 'نشط',
  'cancelled': 'ملغي',
  'completed': 'مكتمل',
  'done': 'تم',
  'draft': 'مسودة',
  'high': 'عالية',
  'in progress': 'قيد التنفيذ',
  'in_progress': 'قيد التنفيذ',
  'low': 'منخفضة',
  'medium': 'متوسطة',
  'on hold': 'متوقف',
  'on_hold': 'متوقف',
  'overdue': 'متأخر',
  'paid': 'مدفوع',
  'pending': 'معلق',
  'planning': 'تخطيط',
  'review': 'مراجعة',
  'sent': 'مرسلة',
  'urgent': 'عاجلة',
};

const phraseEn = Object.fromEntries(Object.entries(phraseAr).map(([english, arabic]) => [arabic, english]));
const dict = { en, ar };

const translateDom = (language) => {
  const source = language === 'ar' ? phraseAr : phraseEn;
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent || ['SCRIPT', 'STYLE', 'TEXTAREA'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
      return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
    },
  });

  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
    const raw = node.nodeValue;
    const trimmed = raw.trim();
    if (source[trimmed]) {
      node.nodeValue = raw.replace(trimmed, source[trimmed]);
    }
  });

  document.querySelectorAll('[placeholder],[title]').forEach(el => {
    ['placeholder', 'title'].forEach(attr => {
      const value = el.getAttribute(attr);
      if (value && source[value]) el.setAttribute(attr, source[value]);
    });
  });
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('tbd_lang') || 'en');
  const value = useMemo(() => ({
    language,
    setLanguage,
    toggleLanguage: () => setLanguage(l => l === 'ar' ? 'en' : 'ar'),
    t: (key) => dict[language]?.[key] || dict.en[key] || key,
  }), [language]);

  useEffect(() => {
    localStorage.setItem('tbd_lang', language);
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.title = language === 'ar' ? 'ذا بلاك ديف' : 'The Black Div';

    translateDom(language);
    const observer = new MutationObserver(() => translateDom(language));
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
